export default "__VITE_ASSET__COXXXA8k__"